// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"c--z"};